import api, { apiWrapper } from '../api/axios';

export const dashboardData = async (
    {
    date = null, month=null, branch = null
  }
) => {
  let params = { };
  if (date != null) {
    params = { ...params, date };
  }
  if (month != null) {
    params = { ...params, month };
  }
  if (branch != null) {
    params = { ...params, branch };
  }
  return apiWrapper(() => api.get(`/dashboard/`, { params }));
};

export const getOverallCount = async () => {
  return apiWrapper(() => api.get(`/overall-count/`));
};
